"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCouponItemPage = getCouponItemPage;
exports.getCouponPackagePage = getCouponPackagePage;
exports.getPackageWithItems = getPackageWithItems;
exports.listEnabledPackages = listEnabledPackages;
exports.updateCouponAlias = updateCouponAlias;
exports.updateCouponImg = updateCouponImg;
exports.updatePackageAlias = updatePackageAlias;
exports.updatePackageEnable = updatePackageEnable;
exports.updatePackageImg = updatePackageImg;
exports.uploadImage = uploadImage;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
// 券包列表
function getCouponPackagePage(params) {
  return (0, _requestAuth.default)({
    url: '/couponPackage/page',
    method: 'get',
    params: params
  });
}
// 券明细列表
function getCouponItemPage(params) {
  return (0, _requestAuth.default)({
    url: '/couponPackage/itemPage',
    method: 'get',
    params: params
  });
}
// 更新启用状态
function updatePackageEnable(data) {
  return (0, _requestAuth.default)({
    url: '/couponPackage/updateEnable',
    method: 'post',
    params: data
  });
}
// 更新券包别名
function updatePackageAlias(data) {
  return (0, _requestAuth.default)({
    url: '/couponPackage/updateAlias',
    method: 'post',
    params: data
  });
}
// 更新券包封面
function updatePackageImg(data) {
  return (0, _requestAuth.default)({
    url: '/couponPackage/updatePkgImg',
    method: 'post',
    params: data
  });
}
// 更新券别名
function updateCouponAlias(data) {
  return (0, _requestAuth.default)({
    url: '/couponPackage/updateCouponAlias',
    method: 'post',
    params: data
  });
}
// 更新券封面
function updateCouponImg(data) {
  return (0, _requestAuth.default)({
    url: '/couponPackage/updateCouponImg',
    method: 'post',
    params: data
  });
}
// 有效券包列表（畅饮卡选择用）
function listEnabledPackages() {
  return (0, _requestAuth.default)({
    url: '/couponPackage/listEnabled',
    method: 'get'
  });
}
// 券包详情含券明细
function getPackageWithItems(id) {
  return (0, _requestAuth.default)({
    url: "/couponPackage/".concat(id, "/withItems"),
    method: 'get'
  });
}
// 上传图片（复用）
function uploadImage(data) {
  return (0, _requestAuth.default)({
    url: '/image/upload',
    method: 'post',
    data: data
  });
}